import { defer } from 'react-router-dom'

export default async function loader() {
  return defer({
    data: Promise.all([]),
  })
}
